import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import InfoHistorial from "../Components/PerfilPaciente/Antecedente/InfoHistorial";
import Cuenta from "../Components/PerfilPaciente/Cuenta";
import Factura from "../Components/PerfilPaciente/Factura";
import Inicio from "../Components/PerfilPaciente/Inicio";
import InfoMedicina from "../Components/PerfilPaciente/Medicina/InfoMedicina";
import InfoOdoNew from "../Components/PerfilPaciente/Odontologia/InfoOdoNew";
import HistorialCitasCompleto from "../Components/PerfilPaciente/HistorialCitasCompleto";
import { ControllerListarPacientesCitas } from "../Service/Service.paciente";
import { json } from "react-router-dom";

export default function HistorialClinico() {
  const [ping, setPing] = useState(false);
  const [infoCita, setInfoCita] = useState(null);
  const [idpaciente, setIdpaciente] = useState(null);
  const dispatch = useDispatch();

  function getLstConsultas() {
    dispatch({
      type: "SET_HISTORIAL",
      payload: !ping,
    });
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const idpacienteParam = urlParams.get("idpaciente");
    const idcita = urlParams.get("idcita");

    setIdpaciente(idpacienteParam);

    if (idpacienteParam) {
      (async () => {
        //alert(JSON.stringify(idpaciente))

        const cit = await ControllerListarPacientesCitas(idpacienteParam);
        //alert(JSON.stringify(cit))
        if (cit.success) {
          setInfoCita(cit.data);
        }
      })();
    }

    if (idcita) {
      setTimeout(() => {
        const tab = document.getElementById("medicina-tab");
        if (tab) {
          tab.click();
        }
      }, 300);
    }
  }, []);

  const handleConsultarPacienteCita = (idcita) => {
    const urlParams = new URLSearchParams(window.location.search);
    const idpaciente = urlParams.get("idpaciente");
    const path = `/paciente_historial?idpaciente=${idpaciente}&idcita=${idcita}`;
    window.open(path, "_blank");
  };

  const handleLlamarPaciente = async (cita) => {
    try {
      const data = {
        topic: "turnero",
        user: "turnero_user",
        pass: "turnero123",
        message: {
          modulo: [cita.doctor.prefijo, cita.doctor.consultorio]
            .filter(Boolean)
            .join(""),
          turno: infoCita?.nombres_completos,
          hora: new Date().toLocaleTimeString(),
          doctor: cita.doctor.nombre,
          estado: "En consulta",
          especialidad: cita.especialidad || "No especificada",
        },
      };

      const response = await fetch(
        "https://colon.smartmedic.site/moquito/api/mqtt",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) throw new Error(`Error: ${response.statusText}`);
      const result = await response.json();
      console.log("Llamado exitoso:", result);
    } catch (error) {
      console.error("Error al llamar paciente:", error);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 font-size-18">Historial Clínico</h4>
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">Historial Clínico</li>
                  <li className="breadcrumb-item active">Listado</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <ul
                  className="nav nav-tabs-custom card-header-tabs"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      className="nav-link px-3 active"
                      data-bs-toggle="tab"
                      href="#home-profile"
                      role="tab"
                    >
                      INICIO
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link px-3"
                      data-bs-toggle="tab"
                      href="#anamnesis"
                      role="tab"
                    >
                      ANTECEDENTES
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link px-3"
                      data-bs-toggle="tab"
                      href="#post"
                      role="tab"
                      id="medicina-tab"
                      onClick={getLstConsultas}
                    >
                      MEDICINA
                    </a>
                  </li>
                  {/* ✅ Agregamos esta nueva pestaña */}
                  {/*<li className="nav-item">
                    <a
                      className="nav-link px-3"
                      data-bs-toggle="tab"
                      href="#odontologia"
                      role="tab"
                    >
                      ODONTOLOGÍA
                    </a>
                  </li>*/}
                  <li className="nav-item">
                    <a
                      className="nav-link px-3"
                      data-bs-toggle="tab"
                      href="#estado-cuenta"
                      role="tab"
                    >
                      ESTADO CUENTA
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link px-3"
                      data-bs-toggle="tab"
                      href="#facturas-paciente"
                      role="tab"
                    >
                      FACTURAS
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link px-3"
                      data-bs-toggle="tab"
                      href="#historial_paciente"
                      role="tab"
                    >
                      HISTORIAL
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="tab-content">
              <div
                className="tab-pane active"
                id="home-profile"
                role="tabpanel"
              >
                <Inicio />
              </div>

              <div className="tab-pane" id="anamnesis" role="tabpanel">
                <div className="card">
                  <div className="card-body">
                    <InfoHistorial />
                  </div>
                </div>
              </div>

              {/*false && (
                <div className="tab-pane" id="odontologia" role="tabpanel">
                  <InfoOdoNew />
                </div>
              )*/}

              <div className="tab-pane" id="historial_paciente" role="tabpanel">
                <div className="card">
                  <div className="card-body">
                    <HistorialCitasCompleto
                      idpaciente={idpaciente}
                      onConsultar={handleConsultarPacienteCita}
                      onLlamar={handleLlamarPaciente}
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane" id="estado-cuenta" role="tabpanel">
                <Cuenta />
              </div>

              <div className="tab-pane" id="facturas-paciente" role="tabpanel">
                <Factura />
              </div>

              <div className="tab-pane" id="post" role="tabpanel">
                <InfoMedicina />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
